import { ThemeColors } from '@lyrahealth-inc/shared-app-logic'

import { getButtonStyles } from './buttonStyles'

export const getAuroraButtonStyles = (tokenColors: ThemeColors) => {
  const defaultButtonStyles = getButtonStyles(tokenColors)

  return {
    ...defaultButtonStyles,
    secondary: {
      ...defaultButtonStyles.secondary,
      default: {
        ...defaultButtonStyles.secondary.default,
        base: {
          color: tokenColors.textInverse,
          borderWidth: 1,
          borderColor: tokenColors.wordCloudButtonOutlineDefault,
          backgroundColor: tokenColors.wordCloudButtonBackgroundDefault,
          backdropFilter: 'blur(4px)',
          minWidth: 100,
        },
      },
    },
    wordCloud: {
      ...defaultButtonStyles.wordCloud,
      default: {
        ...defaultButtonStyles.wordCloud.default,
        base: {
          ...defaultButtonStyles.wordCloud.default.base,
          borderRadius: 60,
          borderWidth: 1,
          borderColor: tokenColors.wordCloudButtonOutlineDefault,
          backgroundColor: tokenColors.wordCloudButtonBackgroundDefault,
          backdropFilter: 'blur(4px)',
        },
      },
    },
  }
}
